import { useMemo } from 'react';

import { Pane, PaneHeader, PaneTitle, PaneBody } from '../components/pane';
import { UnderConstruction } from './UnderConstruction';

const OrdersTable = () => {
  return (
    <UnderConstruction>
      Stay tuned for a summary of all recent orders across sites.
    </UnderConstruction>
  );
};

export type OrdersPaneProps = {
  activeGroupIds: number[];
};

export const OrdersPane = ({ activeGroupIds }: OrdersPaneProps) => {
  const websocketOptions = useMemo(() => {
    return {
      topic: activeGroupIds.map((id) => `${id}.orders.created`),
    };
  }, [activeGroupIds]);

  return (
    <Pane refetchQueryKey="" websocketOptions={websocketOptions}>
      <PaneHeader>
        <PaneTitle>New Orders</PaneTitle>
        {/* <PaneSubtitle>Placed in the last 30 days</PaneSubtitle> */}
      </PaneHeader>
      <PaneBody>
        <OrdersTable />
      </PaneBody>
    </Pane>
  );
};
